import React from "react";
import { Stamp } from "lucide-react";
import ResultBox from "../shared/ResultBox";
import { fmt } from "../utils/format";

export default function FinancialStampResult({ result, toDisplay, unitLabel }) {
  return (
    <>
      <div className="rounded-xl px-5 py-4 bg-neutral-900">
        <div className="text-xs mb-1 text-neutral-400">جمع کل حق‌الوکاله</div>
        <div className="text-lg font-bold text-neutral-200">
          {fmt(toDisplay(result.total))} {unitLabel}
        </div>
      </div>

      <div>
        <div className="flex items-center gap-1 text-xs mb-2 text-neutral-400">
          <Stamp size={13} />
          <span>تمبر مالیاتی — کانون وکلای دادگستری</span>
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          <ResultBox
            label="تمبر مرحله بدوی"
            value={`${fmt(toDisplay(result.kanoonStampFirst))} ${unitLabel}`}
          />
          <ResultBox
            label="تمبر مرحله تجدیدنظر"
            value={`${fmt(toDisplay(result.kanoonStampAppeal))} ${unitLabel}`}
          />
        </div>
      </div>

      <div>
        <div className="flex items-center gap-1 text-xs mb-2 text-neutral-400">
          <Stamp size={13} />
          <span>تمبر مالیاتی — مرکز امور وکلا و مشاوران قوه قضائیه</span>
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          <ResultBox
            label="تمبر مرحله بدوی"
            value={`${fmt(toDisplay(result.markazStampFirst))} ${unitLabel}`}
          />
          <ResultBox
            label="تمبر مرحله تجدیدنظر"
            value={`${fmt(toDisplay(result.markazStampAppeal))} ${unitLabel}`}
          />
        </div>
      </div>
    </>
  );
}
